<template>
  <div class="header__cart-total-details" data-test="cart-payment">
    <div class="header__cart-total-fields" data-test="cart-subtotal-row">
      <p>Subtotal:</p>
      <span data-test="cart-subtotal">${{ cartTotal }}</span>
    </div>

    <div class="header__cart-divider"></div>
    <div class="header__cart-total-fields" data-test="cart-shipping-row">
      <p>Shipping:</p>
      <span data-test="cart-shipping">Free</span>
    </div>
    <div class="header__cart-divider"></div>
    <div class="header__cart-total-fields" data-test="cart-total-row">
      <p>Total:</p>
      <span data-test="cart-total">${{ cartTotal }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { round } from "@/composables/round";
import { useCartStore } from "../store/cart";
import { computed } from "vue";

const cartStore = useCartStore();

const cartTotal = computed(() => {
  const total = cartStore.cartTotal;
  return round(total);
});
</script>

<style lang="scss" scoped>
@use "@/assets/styles/components/cart-payment";
</style>
